// SentenceUnscramble.js
import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  container: {
    marginBottom: 12,
  },
  sentence: {
    marginBottom: 6,
    fontSize: 12,
    lineHeight: 1.4,
  },
  correctAnswer: {
    marginBottom: 6,
    fontSize: 24,
    lineHeight: 1.4,
    fontWeight: 600,
  },
  wordBankContainer: {
    border: 1,
    borderColor: "black",
    borderRadius: 12,
    padding: 12,
  },
});


export default function SentenceUnscramble({ data, typeOfContent }) {
  return (
    <View style={styles.container}>
      {data.map((item, index) => (
        <View
          key={index}
          style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          {typeOfContent === "worksheet_marksheet" ? (
            <Text style={styles.sentence}>
            {index + 1}. {item.sentence}
          </Text>
          ) : (
            <Text style={styles.sentence}>
            {index + 1}. {item.scrambledSentence}
          </Text>
          )}
        </View>
      ))}
    </View>
  );
}
